// extracted by mini-css-extract-plugin
export var container = "_b9-0";
export var icon = "_b9-1";
export var text = "_b9-2";